
import { Component, Vue, Prop } from 'vue-property-decorator';
import { assignClientToPlan, IClientPaymentPlan } from '@/api/clientPaymentPlan';
import { getPlans } from '@/api/plans';
import Input from '@/components/form/input.vue';


@Component({
  name: 'AssignPlan',
  components: { Input }
})
export default class AssignPlan extends Vue {
  @Prop({ type: Number, required: true }) readonly client_account!: number;
  @Prop({ type: String, required: true }) readonly client_name!: string;

  public form = {
    client_account: {
      label: 'Client Account',
      placeholder: 'Enter client account',
      type: 'number',
      required: true
    },
    payment_plan: {
      label: 'Plan',
      placeholder: 'Enter plan',
      type: 'number',
      required: true
    },
  };

  public client_payment_plan: IClientPaymentPlan = {
    client_account: 0,
    payment_plan: 0,
    billing_cycle: 'one_time',
    payment_option: 'Invoice Payment',
    subscription_current_period_end: "",
  };

  public menu = false;
  public available_plans: Array<{ text: string; value: number }> = [];

  public addClientPopup: any = {
    active: false,
    title: '',
    message: '',
    type: '',
    data: null
  };

  async mounted() {
    this.client_payment_plan.client_account = this.client_account;

    try {
      const response: any = await getPlans();
      this.available_plans = (response.data.results || []).map((plan: any) => ({
        text: plan.name,
        value: plan.id
      }));
    } catch (error) {
      this.available_plans = [];
    }
  }

  public submit() {
    assignClientToPlan(this.client_payment_plan).then((response: any) => {
      this.$emit('created', response.data);
    });
  }

  public discard() {
    this.$router.push('/clients');
  }
}
